'use client';

import { messageType, MessageType, SnackBar } from '@wishket/design-system';

import { Toast } from '@/shared/utils';

interface NotifyToastProps {
  message: string;
  type?: MessageType;
}

const notifyToast = ({
  type = messageType.Progress,
  message,
}: NotifyToastProps) => {
  const toast = Toast.getInstance();
  if (!toast) return;

  toast.create(<SnackBar type={type} message={message} />, { duration: 2000 });
};

export default notifyToast;
